import {
  IonContent,
  IonPage,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonButton,
  IonIcon,
} from '@ionic/react';
import { useNavigate } from 'react-router-dom';
import { gameController, sparkles } from 'ionicons/icons';
import AppHeader from '../components/AppHeader';
import BottomNav from '../components/BottomNav';
import './Games.css';

const Games: React.FC = () => {
  const navigate = useNavigate();

  const games = [
    {
      id: 'spin',
      name: 'Spin the Wheel',
      icon: '🎡',
      description: 'Spin and win coins!',
      reward: '10-200 coins',
      status: 'available',
    },
    {
      id: 'scratch',
      name: 'Scratch & Win',
      icon: '🎫',
      description: 'Scratch to reveal your prize!',
      reward: '5-200 coins',
      status: 'available',
    },
    {
      id: 'memory',
      name: 'Memory Match',
      icon: '🧠',
      description: 'Match pairs of cards in this challenging memory game!',
      reward: '50-250 coins',
      status: 'available',
    },
    {
      id: '2048',
      name: '2048 Puzzle',
      icon: '🔢',
      description: 'Merge numbers to reach 2048!',
      reward: 'Based on score',
      status: 'available',
    },
    {
      id: 'snake',
      name: 'Snake Game',
      icon: '🐍',
      description: 'Control the snake and eat food to grow!',
      reward: '1+ coins (per 10 points)',
      status: 'available',
    },
    {
      id: 'bubble',
      name: 'Bubble Shooter',
      icon: '🎯',
      description: 'Aim and shoot to pop matching bubbles!',
      reward: '30-200 coins',
      status: 'available',
    },
    {
      id: 'wordsearch',
      name: 'Word Search',
      icon: '🔍',
      description: 'Find hidden words before time runs out!',
      reward: '50-200 coins',
      status: 'available',
    },
  ];

  const handlePlayGame = (gameId: string) => {
    const routes: { [key: string]: string } = {
      'spin': '/spin-wheel',
      'scratch': '/scratch-card',
      'memory': '/memory-match',
      '2048': '/game-2048',
      'snake': '/snake-game',
      'bubble': '/bubble-shooter',
      'wordsearch': '/word-search',
    };
    
    const route = routes[gameId];
    if (route) {
      navigate(route);
    }
  };

  return (
    <IonPage>
      <AppHeader title="Games" />
      <IonContent fullscreen className="ion-padding">
        <div className="games-container">
          <div className="games-header">
            <IonIcon icon={gameController} className="header-icon" />
            <h2>Earn Coins by Playing</h2>
            <p>Play mini-games and win coins instantly!</p>
          </div>

          <div className="games-grid">
            {games.map((game) => (
              <IonCard
                key={game.id}
                className="game-card"
                onClick={() => handlePlayGame(game.id)}
              >
                <IonCardHeader>
                  <div className="game-icon">{game.icon}</div>
                  <IonCardTitle>{game.name}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <p className="game-description">{game.description}</p>
                  <div className="game-reward">
                    <IonIcon icon={sparkles} />
                    <span>{game.reward}</span>
                  </div>
                  <IonButton
                    expand="block"
                    color="primary"
                    className="play-button"
                  >
                    Play Now
                  </IonButton>
                </IonCardContent>
              </IonCard>
            ))}
          </div>

          <IonCard className="info-card">
            <IonCardContent>
              <h3>💡 Tip</h3>
              <p>
                Play games daily to maximize your coin earnings. Each game has
                different reward ranges!
              </p>
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
      <BottomNav />
    </IonPage>
  );
};

export default Games;

